export default "__VITE_ASSET__3613ca48__"